<template>
  <div class>
    <!-- header start -->
    <van-nav-bar
      title="纪念馆访客记录"
      left-arrow
      fixed
      :z-index="99"
      @click-left="onClickLeft"
      :border="false"
    />
    <div class="navBarSpace"></div>
    <!-- header end -->

    <div>
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          :offset="offset"
          :immediate-check="ischeck"
          finished-text="没有更多了"
          @load="loadMore"
        >
          <van-collapse v-model="activeNames" :border="false">
            <van-collapse-item
              v-for="item in dataList"
              :key="item.Time"
              :title="$moment(item.Time).format('YYYY年MM月DD日')"
              :name="item.Time"
              :border="false"
            >
              <van-row gutter="15">
                <van-col span="6" v-for="citem in item.VisitCalleApiModelList" :key="citem.id">
                  <div class="visitor-list" @click="goPersonInfo(citem.MemberApiModel.SerialNumber)">
                    <div class="image">
                      <van-image
                        width="100%"
                        height="100%"
                        fit="cover"
                        radius="4"
                        :src="citem.MemberApiModel.HeadPic"
                      />
                    </div>
                    <span class="name">{{citem.MemberApiModel.NickName}}</span>
                  </div>
                </van-col>
              </van-row>
            </van-collapse-item>
            <!-- <van-collapse-item title="3月20" name="1" :border="false">
          <van-row gutter="15">
            <van-col span="6" v-for="item in 4" :key="item.id">
              <div class="visitor-list">
                <div class="image">
                  <van-image
                    width="100%"
                    height="100%"
                    fit="cover"
                    radius="4"
                    src="https://img.yzcdn.cn/vant/cat.jpeg"
                  />
                </div>
                <span class="name">张三</span>
              </div>
            </van-col>
          </van-row>
        </van-collapse-item>
        <van-collapse-item title="1月12" name="2" :border="false">
          <van-row gutter="15">
            <van-col span="6" v-for="item in 10" :key="item.id">
              <div class="visitor-list">
                <div class="image">
                  <van-image
                    width="100%"
                    height="100%"
                    fit="cover"
                    radius="4"
                    src="https://img.yzcdn.cn/vant/cat.jpeg"
                  />
                </div>
                <span class="name">张三</span>
              </div>
            </van-col>
          </van-row>
        </van-collapse-item>
        <van-collapse-item title="2015年12月30" name="3" :border="false">
          <van-row gutter="15">
            <van-col span="6" v-for="item in 3" :key="item.id">
              <div class="visitor-list">
                <div class="image">
                  <van-image
                    width="100%"
                    height="100%"
                    fit="cover"
                    radius="4"
                    src="https://img.yzcdn.cn/vant/cat.jpeg"
                  />
                </div>
                <span class="name">张三</span>
              </div>
            </van-col>
          </van-row>
            </van-collapse-item>-->
          </van-collapse>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import { Collapse, CollapseItem } from "vant";
export default {
  data() {
    return {
      activeNames: [],
      id: 0,
      refreshing: false,
      loading: true,
      finished: false,
      offset: 100,
      ischeck: false,
      options: null,
      dataList: [],
      pageRows: 5
    };
  },
  components: {
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem
  },
  //
  methods: {
    onClickLeft() {
      this.$router.go(-1);
	},
	goPersonInfo(id) {
      this.$router.push("/PersonInfo?id="+id);
    },
    init() {
      var that = this;
      that.options = {
        type: "GetMemorialHallVisitCallerList",
        pageRows: that.pageRows,
        pageIndex: 1,
        Id: that.id
      };
      that.getList();
    },
    loadMore() {
      Object.assign(this.options, {
        pageIndex: this.options.pageIndex + 1
      });
      this.loading = true;
      this.getList();
    },
    onRefresh() {
      this.finished = false;
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      Object.assign(this.options, {
        pageIndex: 1
      });
      this.getList();
    },
    getList() {
      var that = this;
      this.$store.dispatch(this.options).then(
        res => {
          that.loading = false;
          if (that.refreshing) {
            that.refreshing = false;
          }
          var dataList = res.GroupVisitCalleApiModelList;
          if (dataList.length <= 0) {
            that.finished = true;
          }
          if (dataList.length < that.pageRows) {
            that.finished = true;
          }

          if (this.options.pageIndex > 1) {
            if (dataList.length > 0) {
              dataList.forEach(element => {
                that.dataList.push(element);
                that.activeNames.push(element.Time);
              });
            }
          } else {
            that.dataList = dataList;
            that.activeNames = [];
            dataList.forEach(e => {
              that.activeNames.push(e.Time);
            });
          }
        },
        error => {}
      );
    }
  },
  created() {
    var that = this;
    this.id = this.$route.query.id;
    this.init();
  }
};
</script>

<style scoped>
.visitor-list {
  display: block;
  overflow: hidden;
  margin-bottom: 10px;
}
.visitor-list > .name {
  display: block;
  font-size: 13px;
  color: #444;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-align: center;
}
</style>